import api from './api';

// Documents
export const getKBDocuments = (params = {}) => api.get('/kb/documents', { params });
export const getKBDocument = (id) => api.get(`/kb/documents/${id}`);
export const updateKBDocument = (id, data) => api.put(`/kb/documents/${id}`, data);
export const deleteKBDocument = (id) => api.delete(`/kb/documents/${id}`);
export const resyncDocument = (id) => api.post(`/kb/documents/${id}/resync`);

// Ingest
export const ingestURL = (data) => api.post('/kb/ingest/url', data);
export const ingestFile = (formData) => api.post('/kb/ingest/file', formData, {
  headers: { 'Content-Type': 'multipart/form-data' },
});

// Search & Stats
export const searchKB = (q, limit = 10) => api.get('/kb/search', { params: { q, limit } });
export const getKBStats = () => api.get('/kb/stats');
